export default function stringIsUndefined(str: string) {
    return str || str === ''; // TODO Validar nulidad
}
